import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardSidebar from '../../components/navigation/DashboardSidebar';
import DashboardHeader from '../../components/navigation/DashboardHeader';
import DashboardFooter from '../../components/navigation/DashboardFooter';
import MobileMenuButton from '../../components/navigation/MobileMenuButton';

import Icon from '../../components/AppIcon';
import RichiestaFerieModal from '../../components/RichiestaFerieModal';

import MojGodisnji from 'components/navigation/MojGodisnji';
import { supabase } from '../../lib/supabase';

const GodisnjiPage = () => {
  const { t } = useTranslation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isRichiestaModalOpen, setIsRichiestaModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const { data: { user } } = await supabase.auth.getUser();
        
        if (user) {
          const { data: profile, error } = await supabase
            .from('profili')
            .select('*')
            .eq('id', user.id)
            .single();
          
          if (error) throw error;
          setUserData(profile);
        }
      } catch (err) {
        console.error("Error fetching profile:", err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchUser();
  }, []);

  const handleRichiestaSuccess = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-background">
      <MobileMenuButton isOpen={isSidebarOpen} onClick={() => setIsSidebarOpen(!isSidebarOpen)} />
      <DashboardSidebar isCollapsed={!isSidebarOpen} onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
      
      <DashboardHeader userName={t('profile_page.title')} />

      <main className="main-content with-sidebar py-10 px-4 mt-20">
        <div className="max-w-5xl mx-auto">
          
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
            <button 
              onClick={() => navigate(-1)} 
              className="group flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors font-bold uppercase text-[10px] tracking-widest"
            >
              <div className="p-2 bg-muted rounded-xl group-hover:bg-primary/10 transition-colors">
                <Icon name="ArrowLeft" size={16} />
              </div>
              {t('profile_page.back')}
            </button>

            {!loading && userData && (
              <button 
                onClick={() => setIsRichiestaModalOpen(true)}
                className="flex items-center justify-center gap-2 bg-primary text-white px-6 py-3 rounded-2xl hover:opacity-90 transition-all group shadow-lg shadow-primary/20 active:scale-95"
              >
                <div className="group-hover:scale-110 transition-transform">
                  <Icon name="Plus" size={20} />
                </div>
                <span className="font-black uppercase text-[10px] tracking-widest">
                  {t('ferie.new_request_btn')}
                </span>
              </button>
            )}
          </div>

          <div className="mb-10">
            <div className="h-1 w-20 bg-primary mt-2 rounded-full"></div>
          </div>

          {!loading && userData?.id ? (
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200">
               <MojGodisnji userId={userData.id} refreshTrigger={refreshTrigger} />
            </div>
          ) : (
            <div className="flex justify-center py-10">
               <Icon name="Loader2" size={24} className="animate-spin text-primary/50" />
            </div>
          )}
          
        </div>
      </main>

      {userData && (
        <RichiestaFerieModal
          isOpen={isRichiestaModalOpen}
          onClose={() => setIsRichiestaModalOpen(false)}
          userId={userData.id}
          onSuccess={handleRichiestaSuccess}
        />
      )}

      <DashboardFooter />
    </div>
  );
};

export default GodisnjiPage;